// @ts-nocheck
// material-ui
import { useTheme } from '@mui/material/styles';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

interface Props {
  open: boolean;
}

// front-end's DrawerHeader, vertical menu only.
const DrawerHeader = ({ open }: Props) => {
  const theme = useTheme();

  return (
    <DrawerHeaderStyled
      theme={theme}
      open={open}
      sx={{
        minHeight: '64px',
        width: 'inherit',
        paddingTop: '16px',
        paddingBottom: '4px',
        paddingLeft: open ? '16px' : 0,
        paddingRight: open ? '16px' : 0
      }}
    >
      <Logo isIcon={!open} sx={{ width: open ? '100%' : 35, height: 35 }} />
    </DrawerHeaderStyled>
  );
};

export default DrawerHeader;
